import axiosInstance from '../axios-instance.ts';
import { ApiResponse, ApiParams } from '@models/api.model.ts';
import {
  DepartmentModel,
  HotelStaffModel,
  HotelStaffReqModel,
  RoleModel
} from '@models/hotel-staff.model.ts';

export const getHotelStaff = async (
  params?: ApiParams
): Promise<ApiResponse<HotelStaffModel>> => {
  const response = await axiosInstance.get('/pms/users/getter', { params });
  return response.data;
};

export const getDepartments = async (): Promise<DepartmentModel[]> => {
  const response = await axiosInstance.get('/pms/departments');
  return response.data;
};

export const getDepartmentUnits = async (): Promise<any[]> => {
  const response = await axiosInstance.get('/pms/departmentUnits');
  return response.data;
};

export const getRoles = async (): Promise<RoleModel[]> => {
  const response = await axiosInstance.get('/pms/users/roles');
  return response.data;
};

export const createStaff = async (
  body: HotelStaffReqModel
): Promise<HotelStaffModel> => {
  return await axiosInstance.post(`/pms/users`, body);
};

export const editStaff = async (
  body: HotelStaffReqModel,
  id: number
): Promise<HotelStaffModel> => {
  return await axiosInstance.put(`/pms/users/${id}`, body);
};

export const changeStatus = async (
  id: number,
  isActive: boolean
): Promise<any> => {
  const response = await axiosInstance.put(`/pms/users/${id}/changeStatus`, {
    isActive
  });
  return response.data;
};
